var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15442",
    "data-name": "\\uADF8\\uB8F9 15442",
    transform: "translate(-8422 12895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15441",
    "data-name": "\\uADF8\\uB8F9 15441",
    transform: "translate(5746 -1578)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8701",
    "data-name": "\\uC0AC\\uAC01\\uD615 8701",
    width: 32,
    height: 32,
    rx: 2,
    transform: "translate(2676 -11317)",
    fill: "rgba(45,52,72,0.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8702",
    "data-name": "\\uC0AC\\uAC01\\uD615 8702",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(2680 -11313)",
    fill: "#2d3448"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_84",
    "data-name": "\\uD569\\uCE58\\uAE30 84",
    d: "M.818,15.059a1.3,1.3,0,0,1,0-1.834L6.1,7.938.818,2.652A1.3,1.3,0,0,1,2.652.818L7.938,6.1,13.224.819a1.3,1.3,0,0,1,1.834,1.834L9.773,7.938l5.285,5.285a1.3,1.3,0,0,1-1.834,1.834L7.938,9.773,2.652,15.059a1.3,1.3,0,0,1-1.834,0Z",
    transform: "translate(8430.063 -12886.938)",
    fill: "#676c7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingNone);
export default __webpack_public_path__ + "static/media/parking_none.bc7ca6a5afe6b3c6e342d2735c48d10e.svg";
export { ForwardRef as ReactComponent };